<template>
    <div>
       <div class="rightFBox">
           <a href="https://work.weixin.qq.com/kfid/kfc87c1dbbc549901e5" class="tel"></a>
           <a href="https://a.app.qq.com/o/simple.jsp?pkgname=com.yunlian.xiechuanwang&channel=0002160650432d595942&fromcase=60001" class="loadArrow"></a>
       </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
         visible:false,
         subFlag:true
        }
    },
    created(){

    },
    methods:{


    }
}
</script>
<style lang='less' rel='stylesheet/less'>
   @rem:16rem;
   .rightFBox{
       position: fixed;
       right: 0.2rem;
       bottom: 1.2rem;
       .tel{
            display: block;
            width: 46/@rem;
            height: 46/@rem;
            background-image: url(../../assets/service.png);
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 100% 100%;
       }
        .loadArrow{
            display: block;
            width: 46/@rem;
            height: 46/@rem;
            background-image: url(../../assets/side-download.png);
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 100% 100%;
       }
   }

</style>



// WEBPACK FOOTER //
// src/components/nav/rightFloat.vue